<div class="container-fluid">
  <div class="card">
    <div class="card-header pb-0">
      <div class="media-space-between">
        <h4>
          {{
            (isLPUser
              ? "admin.locations.campaigns.titleLP"
              : "admin.locations.campaigns.title"
            ) | translate
          }}
        </h4>
        <div class="media-body">
          <div class="media-space-between">
            <app-search-field
              class="m-r-10"
              [form]="formFilter | asFormGroup"
              [filterOptions]="null"
              inputFormControlName="title"
              [placeholder]="'placeholder.searchByCampaignTitle' | translate"
            ></app-search-field>
            <div class="m-r-10" *ngIf="!isLPUser && !isFranchiseUser">
              <button
                class="btn btn-primary"
                type="button"
                style="width: max-content"
                (click)="addCampaign()"
              >
                {{ "buttons.addCampaign" | translate }}
              </button>
            </div>
            <div class="m-r-10" *ngIf="isFranchiseUser">
              <a
                class="btn btn-outline-primary project-box"
                data-bs-toggle="modal"
                [ngbTooltip]="'export.title' | translate"
                data-bs-target="#exportFile"
                (click)="exportToCsv()"
              >
                <i class="icon-import"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card-body">
      <div class="table-responsive data-table">
        <form>
          <table class="table table-striped table-border-vertical">
            <thead>
              <tr>
                <ng-container *ngFor="let column of columns">
                  <th
                    sortable
                    class="sortable"
                    sortable="{{ column.key }}"
                    (sort)="onSort($event)"
                  >
                    {{ column.label | translate }}
                  </th>
                </ng-container>
                <th>
                  {{ "admin.locations.campaigns.status" | translate }}
                </th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody *ngIf="!(loading$ | async)">
              <ng-container
                *ngFor="let ad of resultAdvertisingCampaigns; let i = index"
              >
                <tr>
                  <ng-template #none>
                    <td>
                      {{ "undefined" | translate }}
                    </td>
                  </ng-template>
                  <td *ngIf="ad.title != null; else none">
                    <a
                      type="button"
                      [routerLink]="
                        isLPUser
                          ? [
                              '/',
                              'dashboard',
                              'location-partner',
                              'LPCampaigns',
                              'statistics',
                              ad.advertisingCampaignHashedId
                            ]
                          : isFranchiseUser
                          ? [
                              '/',
                              'dashboard',
                              'franchise',
                              'location-partners',
                              'campagnes',
                              'statistics',
                              ad.advertisingCampaignHashedId
                            ]
                          : [
                              '/',
                              'dashboard',
                              'admin',
                              'location-partners',
                              'campagnes',
                              'statistics',
                              ad.advertisingCampaignHashedId
                            ]
                      "
                      style="color: black"
                    >
                      <td>
                        {{ ad.title }}
                      </td>
                    </a>
                  </td>
                  <ng-container *ngIf="!isLPUser">
                    <td>
                      <app-column-location-partners
                        [locationPartners]="ad.locationPartners"
                        [j]="i"
                      ></app-column-location-partners>
                    </td>
                  </ng-container>
                  <ng-container *ngIf="!isLPUser">
                    <td *ngIf="ad.objectiveName != null; else none">
                      {{
                        "enumMapping.objectives." + ad.objectiveName | translate
                      }}
                    </td>
                  </ng-container>
                  <td *ngIf="ad.publishDate != null; else none">
                    {{ ad.publishDate | localizedDate : "short" }}
                  </td>
                  <td *ngIf="ad.status != null; else none">
                    <span
                      [ngClass]="
                        'badge ' +
                        badgeService.getBadgeForAdvertisingCampaingStatus(
                          ad.status
                        )
                      "
                    >
                      {{
                        "enumMapping.campaigns.status." + ad.status | translate
                      }}
                    </span>
                  </td>
                  <td>
                    <app-drop-zone-options
                      [options]="getOptions(ad)"
                      (optionSelected)="saveOption($event, ad)"
                    ></app-drop-zone-options>
                  </td>
                </tr>
              </ng-container>
            </tbody>
          </table>
          <div *ngIf="forbidden" class="d-flex justify-content-center m-t-20">
            {{ "response.error.FORBIDDEN_RESPONSE" | translate }}
          </div>
          <div
            *ngIf="this.count == 0 && !(loading$ | async) && !forbidden"
            class="d-flex justify-content-center m-t-20"
          >
            {{ "noData" | translate }}
          </div>
          <div *ngIf="(loading$ | async) && !forbidden">
            <ng-container style="float: right" class="flex">
              <div class="loader-box">
                <div class="loader-34"></div>
              </div>
              <h6
                class="col align-self-center f-w-600"
                style="text-align: center"
              >
                {{ "fetching" | translate }}
              </h6>
            </ng-container>
          </div>
        </form>
      </div>
      <div class="table-responsive data-table">
        <app-pager
          [count]="(resultFilterAdvertisingCampaigns$ | async)?.count ?? 0"
          [pageSize]="pageSize"
          [pageNumber]="pageNumber"
          (emitChangePage)="changePage($event)"
          (emitChangePageSize)="itemsPerPageChange($event)"
        ></app-pager>
      </div>
    </div>
  </div>
</div>
